import React from 'react';
import {BaseMixin, ElementaryMixin, NestingLevelMixin, SectionMixin} from '../common/common.js';
import './row.less'

export const Row = React.createClass({

  //@@viewOn:mixins
  mixins: [
    BaseMixin,
    ElementaryMixin,
    NestingLevelMixin,
    SectionMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: 'UU5.Bricks.Row',
    nestingLevelList: ['spa', 'page', 'bigBoxCollection', 'bigBoxCollection', 'boxCollection', 'box','smallBoxCollection'],
    classNames: {
      main: 'uu5-bricks-row',
      standard: 'uu5-bricks-row-standard',
      flex: 'uu5-bricks-row-flex'
    },
    opt: {
      nestingLevelWrapper: true
    }
  },
  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    display: React.PropTypes.oneOf(['standard', 'flex'])
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      display: 'standard'
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  shouldComponentUpdate(nextProps, nextState) {
    return this.shouldRender(nextProps, nextState);
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getMainAttrs() {
    let mainAttrs = this.buildMainAttrs();

    mainAttrs.className +=  ' ' + this.getClassName(this.props.display);

    return mainAttrs;
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render() {
    return (
      this.getNestingLevel()
        ? (
        <div {...this._getMainAttrs()}>
          {this.getHeaderChild()}
          {this.getChildren()}
          {this.getFooterChild()}
          {this.getDisabledCover()}
        </div>
      ) : null
    );
  }
  //@@viewOff:render
});

export default Row;



// WEBPACK FOOTER //
// ./bricks/row.js